<nav class="navbar navbar-expand-md navbar-br-bt">
  <a [routerLink]='disallowNavigation ? [] : ["/"]' class="navbar-brand">
    <div class="d-none d-md-block"><img src="../../assets/img/logo.png" class="list-inline" /></div>
    <div class="d-md-none"><i class="fa fa-lg fa-university text-dark"> CAP</i></div>
  </a>
  <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#collapsingNavbar">
    <span class="navbar-toggler-icon"><span class="fa fa-bars"></span></span>
  </button>
  <div class="navbar-collapse collapse justify-content-stretch" id="collapsingNavbar" *ngIf='userAvailable && !disallowNavigation'>
    <ul class="navbar-nav ml-auto">
      <li class="nav-item" [routerLinkActive]='["invisible"]' [routerLink]='["/dashboard"]'>
        <button class="btn btn-link text-dark" (click)="backToDashboard()"><i class="fa fa-tachometer" aria-hidden="true"></i>&nbsp;Back To Dashboard</button>
      </li>
      <li class="nav-item dropdown">
        <button type="button" class="btn btn-link text-dark dropdown-toggle" dropdown-toggle id="dropdownMenuUser" data-toggle="dropdown">
          <i class="fa fa-user-circle-o"></i> {{user}}
        </button>
        <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuUser">
          <a class="dropdown-item" (click)='editProfile($event)' style='cursor: pointer'><i class="fa fa-user"></i> Edit Profile</a>
          <a class="dropdown-item" (click)="logout()" style='cursor: pointer'><i class="fa fa-lock"></i> Logout</a>
        </div>
      </li>
    </ul>
  </div>
</nav>

<ng-template #profileBlock>
  <p style="color: red;">Hello, {{user}}</p>
  <button (click)="logout()" class="btn btn-danger navbar-btn login-btn">Logout</button>
</ng-template>
